export default __webpack_public_path__ + "static/media/logo2.1eb4811c.png";